import defaultOverrides from "@oai/platform/defaults"
import merge from "lodash/merge"
import type { PlatformUIKitDefaults } from "./types"

const DEFAULT_DEFAULTS: Required<PlatformUIKitDefaults> = {
  backdropStyle: "dim",
  iconNextVariant: "light",
  pill: false,
  pressableScaleMultiplier: 1,
}

/**
 * Global, build-time defaults for PUIK components.
 *
 * Consumers can alias this module to a local file to override these values
 * without adding runtime providers or hooks.
 */
export const defaults: Required<PlatformUIKitDefaults> = merge(DEFAULT_DEFAULTS, defaultOverrides)
